<script setup>
import { onMounted } from 'vue';
import { useRequestsStore } from '@/stores/storeRequests';
import { useModals } from '@/composables/useModals';
import { set } from 'browser-cookies';

const storeRequests = useRequestsStore();
const { triggerQrScan } = useModals();

onMounted( async ( ) => {
    await storeRequests.userInfo();
    setTimeout( () => triggerQrScan(), 500);
})
</script>
<template>
   
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>